import styled from 'styled-components';
import Button from '../../components/Button';

import { textGrey, outlineGray } from '../../config/colors';

export const LoginScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  min-height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
export const LoginWrapper = styled.div`
  width: 40%;
  margin: 0 auto;
`;

export const LogoAndTitleWrapper = styled.div`
  width: 100%;
  height: 70%;
`;

export const Logo = styled.img`
  width: 100%;
  height: 85%;
`;

export const Title = styled.h1`
  text-align: right;
  margin: 0 0 15px 0;
  font-size: 2.313rem;
  font-weight: 600;
  color: ${textGrey};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem;
`;

export const SubmitButton = styled(Button).attrs({
  wrapperStyle: {
    float: 'right',
  },
})``;

export const ErrorMsg = styled.h2`
  color: red;
  font-size: 1rem;
  margin-left: 10px;
`;
